module.exports = __webpack_public_path__ + "img/war_horse.f2061c46.jpg";